import React from 'react';
import { Editor } from 'components';
import Container from "./Container";
import Page from './Page';

class Template extends React.Component {
  constructor(props) {
    super(props);
    this.tmplRef = React.createRef();
  }

  render() {
    const {
      changeContent,
      product,
      content,
      removableArea: RemovableArea
    } = this.props;

    return (
      <Container containerRef={this.props.containerRef}>
        <Page
          removableArea={RemovableArea}
          product={product}
          pageRef={this.tmplRef}
        >
          <Editor
            content={content?.section1}
            setContent={(value) => changeContent('section1', value)}
          />
        </Page>
      </Container>
    );
  }
}

export default Template;
